{
  "loadFailed": "ไม่สามารถโหลดข้อมูลการชำระเงินได้",
  "paymentCompleted": "ทำรายการเสร็จสิ้น",
  "unverifiedTradeFailed": "การทำรายการล้มเหลวเนื่องจากยังไม่ได้ยืนยันตัวตน หากมีข้อสงสัยโปรดติดต่อฝ่ายบริการลูกค้า",
  "paymentFailed": "ชำระเงินไม่สำเร็จ",
  "confirmPayment": "ยืนยันการชำระเงิน",
  "myBalance": "ยอดคงเหลือของฉัน",
  "bonusBalance": "ยอดคงเหลือโบนัส",
  "totalPayable": "ยอดรวมที่ชำระได้",
  "insufficientAvailableBalance": "ยอดคงเหลือที่ใช้ได้ของคุณไม่เพียงพอ"
}
